import type { BuildingFormInput } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";

export const BUILDING_FORM_DEFAULT_VALUES: BuildingFormInput = {
	name: "",
	location: "",
	locationMunicipality: "",
	locationZipCode: "",
	usableArea: null,
	floorArea: null,
	householdArea: null,
	landSize: null,
	disposition: null,
	buildingMaterial: null,
	numberOfFloors: null,
	amenities: [],
	marketValue: null,
	reproductionValue: null,
	interiorValue: null,
	purchaseDate: null,
	description: "",
	forInvestments: false,
};
